import { render, staticRenderFns } from "./BiobankAlert.vue?vue&type=template&id=afddcde8&"
import script from "./BiobankAlert.vue?vue&type=script&lang=ts&"
export * from "./BiobankAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports